<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row mb-4">
      <div class="col">
        <button
          v-b-tooltip.hover
          title="Voltar"
          @click="$router.push({ path: '/acompanhamento-projetos/listar' })"
          class="btn btn-light border shadow-sm text-dark"
        >
          <font-awesome-icon icon="chevron-left" /> Voltar
        </button>
      </div>
    </div>
    <div>
      <fcc-adicionar-projeto-form :disabled="true" :project-id="id" />
    </div>
    <div>
      <fcc-etapas :project-id="id" />
    </div>
  </div>
</template>
<script>
import fccAdicionarProjetoForm from '../components/fccAdicionarProjetoForm.vue'
import fccEtapas from './fccEtapas.vue'
import store from '@/store'

export default {
  components: { fccAdicionarProjetoForm, fccEtapas },
  data() {
    return {
      titlePage: 'Editar Projeto'
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.carregaTexto(this.codeMensagem('C01'))

    store
      .dispatch('acompanhamentoDeProjetos/fetchAll', {
        config: this.dadosLoginSession.fccTokenHeaders,
        actions: ['Solicitantes', 'Equipes', 'Sistemas', 'SituacoesProjeto']
      })
      .then(() =>
        store.dispatch(
          'acompanhamentoDeProjetos/fetchProjeto',
          this.id,
          this.dadosLoginSession.fccTokenHeaders
        )
      )
      .catch(this.setErrorSystem)
      .finally(this.carregaTexto)
  }
}
</script>